import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {TestRunService} from "../services/test-run.service";

@Injectable({
  providedIn: 'root',
})
export class TestRunResolver implements Resolve<void> {
  constructor(private testRunService: TestRunService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
    const testRunParam = route.queryParamMap.get('testRun');
    const isTestRun = testRunParam === 'true';
    this.testRunService.setTestRun(isTestRun);
  }
}
